export const SUPPORTED_DATE_TIME_LOCALES = [
  'en-AU', 'en-NZ', 'en-GB', 'en-US', 'en-CA',
  'de-DE', 'fr-FR', 'ja-JP', 'en-IN', 'en-SG',
] as const;

export type DateTimeLocale = typeof SUPPORTED_DATE_TIME_LOCALES[number];
export type HourCycle = 'h12' | 'h23';

export interface UserDateTimePreferences {
  dateTimeLocale: DateTimeLocale | null;
  hourCycle: HourCycle | null;
}